<template>
    <!-- 首页 -->
    <div class='page_index'>
        <!-- 内容 -->
        <div class="body_part">
            <div class="left">
                <div v-if="purchaseShow">
                    <border-line
                        :tenderImg="ingredientsImg"
                        :isLeft="false"
                        width="457"
                        height="885"
                        left="145"
                        title="采购信息公示"
                    >
                        <div class="page_padding">
                            <!-- <item-list
                                :rankList="ingredientsList"
                                :isShow="true"
                                :active="0"
                                scrollHeight="685"
                                scrollItemHeight="87%"
                                :isStep="ingredientsList.length>=6"
                            ></item-list> -->
                            <article-list
                                :rankList="ingredientsList"
                                scrollHeight="785"
                                :active="0"
                                scrollItemHeight="90%"
                                :isStep="ingredientsList.length>=6"
                            ></article-list>
                        </div>
                    </border-line>
                    <!-- <border-line
                        :tenderImg="fuelImg"
                        :isLeft="false"
                        width="457"
                        height="173"
                        left="145"
                        title="燃料价格公示"
                    >
                        <div class="page_padding">
                            <item-list
                                :rankList="fuelList"
                                :isShow="true"
                                :active="0"
                                scrollHeight="685"
                                scrollItemHeight="10%"
                                :borderWidth="140"
                                :isStep="fuelList.length>=2"
                            ></item-list>
                        </div>
                    </border-line> -->
                </div>

                <div v-show="mealShow">
                    <border-line
                        :tenderImg="mealImg"
                        :isLeft="false"
                        width="457"
                        height="885"
                        left="145"
                        title="供餐价格公示"
                    >
                        <div class="page_padding">
                            <item-title
                                title="统缴餐"
                                subTitle="单位：元/份"
                            ></item-title>
                            <item-list
                                :rankList="mealList"
                                scrollHeight="200"
                                :active="0"
                                :borderWidth="266"
                            ></item-list>
                            <!-- <div class="page_line"></div> -->
                            <item-title title="自选餐"></item-title>
                            <item-list
                                :rankList="optionalMealList"
                                scrollHeight="420"
                                :active="0"
                                :borderWidth="170"
                                scrollItemHeight="92%"
                                :isStep="optionalMealList.length>=11"
                            ></item-list>
                        </div>
                    </border-line>
                </div>

                <div v-show="incomeShow">
                    <border-line
                        :tenderImg="mealImg"
                        :isLeft="false"
                        width="457"
                        height="885"
                        left="145"
                        title="收入费用公示"
                    >
                        <div class="revenueExpense">
                            <div>{{monySum.isUse==1?'结账':'公示'}}月份：</div>
                            <div>{{ year }}年{{ time }}</div>
                        </div>
                        <!-- 上期盈余 -->
                        <div class="currentSurplus" v-if="monySum.isUse==1">
                            <div>上期盈余</div>
                            <div>{{monySum.prePeriodEarnings}}元</div>
                        </div>
                        <!-- 本期收入 -->
                        <div
                            :class="index==0?'currentSurplus':'currentSurplusActive'"
                            v-for="(item,index) in currentSurplusArr"
                            :key="index"
                        >
                            <div>{{item.title}}</div>
                            <div>{{item.num}}元</div>
                        </div>
                        <!--本期费用  -->
                        <div
                            :class="index==0?'currentExpenses':'currentSurplusActive'"
                            v-for="(item,index) in currentExpensesArr"
                            :key="index"
                        >
                            <div>{{item.title}}</div>
                            <div>{{item.num}}元</div>
                        </div>
                        <!-- 累计盈余 -->
                        <div class="accumulatedSurplus" v-if="monySum.isUse==1">
                            <div>累计盈余</div>
                            <div>{{monySum.allPeriodEarnings}}元</div>
                        </div>
                    </border-line>
                </div>

                <div v-show="violateShow">
                    <border-line
                        :tenderImg="violationsImg"
                        :isLeft="false"
                        width="457"
                        height="885"
                        left="145"
                        title="违规整改公示"
                    >
                        <div class="page_padding">
                            <item-title
                                title="本月违规预警"
                                :subTitle="time"
                                :imgLeftList="imgLeftList"
                                :imgRightList="imgRightList"
                            ></item-title>
                            <div class="page_right">
                                <div>
                                    <big-num
                                        :num="illegalTotal.monthViolationCount >=0 ? illegalTotal.monthViolationCount : '--'"
                                        unit="条"
                                        title="违规"
                                        color="#FFFFFF"
                                    ></big-num>
                                </div>
                                <div>
                                    <big-num
                                        :num="illegalTotal.monthRectificationCount >= 0 ? illegalTotal.monthRectificationCount : '--'"
                                        unit="条"
                                        title="整改"
                                        color="#FFFFFF"
                                        subColor="#86FFAE"
                                    ></big-num>
                                </div>
                            </div>
                            <item-title
                                title="累计违规预警"
                                :imgLeftList="imgLeftList"
                                :imgRightList="imgRightList"
                            ></item-title>
                            <div class="page_right">
                                <div>
                                    <big-num
                                        :num="illegalTotal.cumulativeViolationCount >= 0 ? illegalTotal.cumulativeViolationCount : '--'"
                                        unit="条"
                                        title="违规"
                                        color="#FFFFFF"
                                    ></big-num>
                                </div>
                                <div>
                                    <big-num
                                        :num="illegalTotal.cumulativeRectificationCount >= 0 ? illegalTotal.cumulativeRectificationCount : '--'"
                                        unit="条"
                                        title="整改"
                                        color="#FFFFFF"
                                        subColor="#86FFAE"
                                    ></big-num>
                                </div>
                            </div>
                            <!-- <div class="page_line_right"></div>
                            <div class="page_article">
                                <article-list
                                    :rankList="articleList"
                                    scrollHeight="400"
                                    :active="0"
                                    scrollItemHeight="94%"
                                    :isStep="articleList.length>=5"
                                ></article-list>
                            </div> -->
                        </div>
                    </border-line>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import borderLine from '@/components/border'; // 边框
import itemList from '@/components/itemList'; // 文字列表
import itemTitle from '@/components/itemTitle'; // 标题
import bigNum from '@/components/bigNum'; // 标题
import articleList from '@/components/articleList'; // 标题
import { keepTwoDecimalFull, filterTime } from "@/assets/js/common";

export default {
    components: {
        borderLine,
        itemList,
        itemTitle,
        bigNum,
        articleList
    },
    data() {
        //这里存放数据
        return {
            year: new Date().getFullYear(),
            time: '',
            deptId: '',
            imgLeftList: require("@/assets/images/icon_left02.png"),
            imgRightList: require("@/assets/images/icon_right02.png"),
            ingredientsImg: require("@/assets/images/border/bg_shicai.png"), // 食材价格公示边框图
            fuelImg: require("@/assets/images/border/bg_ranliao.png"), // 燃料价格公示边框图
            mealImg: require("@/assets/images/border/bg_gongcan.png"), // 供餐价格公示边框图
            violationsImg: require("@/assets/images/border/bg_weigui.png"), // 食堂违规预警公示边框图
			// 显示窗体
			purchaseShow: false,
			mealShow: false,
			incomeShow: false,
			violateShow: false,
            // 食材价格
            ingredientsList: [],
            // 燃料价格
            fuelList: [],
            // 统缴餐
            mealList: [],
            // 自选餐
            optionalMealList: [],
            // 总收入
            incomeList: [
                {
                    name: '餐费收入',
                    price: '--元'
                },
                {
                    name: '厨废收入',
                    price: '--元'
                },
                {
                    name: '利息收入',
                    price: '--元'
                },
                {
                    name: '其他收入',
                    price: '--元'
                }
            ],
            // 总支出
            spendingList: [
                {
                    name: '采购支出(食材)',
                    price: '--元'
                },
                {
                    name: '采购支出(燃料)',
                    price: '--元'
                },
                {
                    name: '人员支出',
                    price: '--元'
                },
                {
                    name: '接待支出',
                    price: '--元'
                },
                {
                    name: '其他支出',
                    price: '--元'
                }
            ],
            // 结余总额
            balanceList: [
                {
                    name: '结余总额',
                    price: '--元'
                }
            ],
            illegalTotal: {},
            articleList: [],
            //2022//12/3 收入费用公示
            monySum: {},
            currentSurplusArr: [],
            currentExpensesArr: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        $route(to) {
            console.log(to, 'url值改变')
            if (Object.keys(to.query).length > 0) {
                let did = to.query.id;
                this.deptId = !did ? localStorage.getItem('deptId') : did;
            } else {
                this.deptId = ''
            }
            this.getData()
        }
    },
    //方法集合
    methods: {
        getShowDivs() {
            this.$get(this.$api.getShowDivs, {
                deptId: this.deptId ? this.deptId : localStorage.getItem('deptId')
            }).then(res => {
                console.log('显示窗体-res', res);
                if (res.code == 200 && res.success) {
                    res.data.forEach(ele => {
                        switch (ele) {
                            case 'purchase':
                                this.purchaseShow = true;
                                break;
                            case 'meal':
                                this.mealShow = true;
                                break;
                            case 'income':
                                this.incomeShow = true;
                                break;
                            case 'violate':
                                this.violateShow = true;
                                break;
                        }
                    })
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('显示窗体-err', err);
            });
        },
        initData() {
            // 食材价格
            this.ingredientsList = []
            // 燃料价格
            this.fuelList = []
            // 统缴餐
            this.mealList = []
            // 自选餐
            this.optionalMealList = []
            // 总收入
            this.incomeList = [
                {
                    name: '餐费收入',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '厨废收入',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '利息收入',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '其他收入',
                    price: '--',
                    expenditureUnit: '元'
                }
            ]
            // 总支出
            this.spendingList = [
                {
                    name: '采购支出(食材)',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '采购支出(燃料)',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '人员支出',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '接待支出',
                    price: '--',
                    expenditureUnit: '元'
                },
                {
                    name: '其他支出',
                    price: '--',
                    expenditureUnit: '元'
                }
            ]
            // 结余总额
            this.balanceList = [
                {
                    name: '结余总额',
                    price: '--',
                    expenditureUnit: '元'
                }
            ]
            this.illegalTotal = {}
            this.articleList = []
        },
        /**
         * @function getPurchasePricePage 食堂餐价公示
         * @param deptId 食堂id
         * @param type 类型：0食材，1燃料
         * @param current 
         * @param size
         */
        getPurchasePricePage() {
            this.$get(this.$api.getPurchasePricePage, {
                deptId: this.deptId,
                current: 1,
                size: 10000
            }).then(res => {
                console.log('食堂餐价公示-res', res)
                const { code, success, data: {
                    records
                } } = res
                if (code == 200 && success) {
                    this.ingredientsList = records
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('食堂餐价公示-err', err)
            })
        },
        /**
         * @function getOpenMealPriceList 供餐价格公示列表（统缴餐）
         * @param deptId 食堂id
         */
        getOpenMealPriceList() {
            this.$get(this.$api.getOpenMealPriceList, {
                deptId: this.deptId
            }).then(res => {
                console.log('供餐价格公示列表（统缴餐）-res', res)
                const { code, success, message, data } = res
                if (code == 200 && success) {

                    if (data.length > 0) {
                        data.forEach(item => {
                            item.name = item.type === '0' ? '早餐' : item.type === '1' ? '中餐' : item.type === '2' ? '晚餐' : '夜餐'
                        });
                        this.mealList = data
                    }
                } else {
                    this.$message({
                        message: message || '食堂id不能为空',
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('供餐价格公示列表（统缴餐）-err', err)
            })
        },
        /**
         * @function getFoodInformationPage 获取餐价公开列表（自选餐）
         * @param deptId 食堂id
         * @param current 
         * @param size
         */
        getFoodInformationPage() {
            this.$get(this.$api.getFoodInformationPage, {
                deptId: this.deptId,
                current: 1,
                size: 10000
            }).then(res => {
                console.log('获取餐价公开列表（自选餐）-res', res)
                const { code, success, data: { records } } = res
                if (code == 200 && success) {
                    this.optionalMealList = records
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('获取餐价公开列表（自选餐）-err', err)
            })
        },
        /**
         * @function getIncomeExpenditureTotal 食堂收支结余公示
         * @param deptId 食堂id
         * @param dateType 数据类型范围（1:只查年，2:只查月，3:只查日，默认为2）
         */
        getIncomeExpenditureTotal() {
            this.$get(this.$api.getIncomeExpenditureTotal, {
                deptId: this.deptId,
                dateType: 2
            }).then(res => {
                console.log('食堂收支结余公示-res', res)
                const { code, success, data } = res
                if (code == 200 && success) {
                    if (Object.keys(data).length > 0) {
                        // 总收入
                        this.incomeList = [
                            {
                                name: '餐费收入',
                                price: `${keepTwoDecimalFull(data.mealIncome)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '厨废收入',
                                price: `${keepTwoDecimalFull(data.kitchenIncome)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '利息收入',
                                price: `${keepTwoDecimalFull(data.interestIncome)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '其他收入',
                                price: `${keepTwoDecimalFull(data.otherIncome)}`,
                                expenditureUnit: '元'
                            }
                        ]
                        // 总支出
                        this.spendingList = [
                            {
                                name: '采购支出(食材)',
                                price: `${keepTwoDecimalFull(data.foodPurchaseExpenditure)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '采购支出(燃料)',
                                price: `${keepTwoDecimalFull(data.fuelPurchaseExpenditure)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '人员支出',
                                price: `${keepTwoDecimalFull(data.wagesExpenditure)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '接待支出',
                                price: `${keepTwoDecimalFull(data.entertainExpenditure)}`,
                                expenditureUnit: '元'
                            },
                            {
                                name: '其他支出',
                                price: `${keepTwoDecimalFull(data.otherExpenditure)}`,
                                expenditureUnit: '元'
                            }
                        ]
                        // 结余总额
                        this.balanceList = [
                            {
                                name: '结余总额',
                                price: `${data.totalBalance}`,
                                expenditureUnit: '元'
                            }
                        ]
                    }
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('食堂收支结余公示-err', err)
            })
        },
        /**
         * @function getIllegalTotal 食堂违规预警公示总数
         * @param deptId 食堂id
         */
        getIllegalTotal() {
            this.$get(this.$api.getIllegalTotal, {
                deptId: this.deptId
            }).then(res => {
                console.log('食堂违规预警公示总数-res', res)
                const { code, success, data } = res
                if (code == 200 && success) {
                    this.illegalTotal = data
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('食堂违规预警公示总数-err', err)
            })
        },
        /**
         * @function getIllegalPage 食堂违规预警公示（列表）
         * @param deptId 食堂id
         * @param dateType 数据类型范围（1:只查年，2:只查月，3:只查日，默认为2）
         * @param current 
         * @param size
         */
        getIllegalPage() {

            this.$get(this.$api.getIllegalPage, {
                deptId: this.deptId,
                dateType: 2,
                current: 1,
                size: 10000
            }).then(res => {
                console.log('食堂违规预警公示（列表）-res', res)
                const { code, success, data: { records } } = res
                if (code == 200 && success) {
                    records.forEach(item => {
                        item.date = filterTime(item.date)
                    })
                    this.articleList = records
                }
            }).catch(err => {
                this.$message.error(err.message);
                console.log('食堂违规预警公示（列表）-err', err)
            })
        },
        getData() {
            let myDate = new Date();
            // let tYear = myDate.getFullYear();
            let tMonth = myDate.getMonth() + 1;
            this.time = `${tMonth}月份`
            this.deptId = localStorage.getItem('deptId')
            // this.deptId = '1466336161432678401'
            this.initData()
            this.getPurchasePricePage()
            this.getOpenMealPriceList()
            this.getFoodInformationPage()
            this.getIncomeExpenditureTotal()
            this.getIllegalTotal()
            this.getIllegalPage()
            this.getRecord() //收入费用公示
        },
        // 收入费用公示
        getRecord() {
            this.$get(this.$api.getRecord, {
                deptId: this.deptId,
                peroidMonth: this.time
            }).then(res => {
                console.log(res, '收入费用公示*************');
                if (res.code === 200) {
                    let { prePeriodEarnings, totalIncome, totalFee, foodIncome, schoolSubsidyIncome, interestIncome, otherIncome, financialSubsidyIncome, foodCostFee, assetDisposalFee, isUse, allPeriodEarnings } = res.data
                    this.monySum = {
                        prePeriodEarnings, isUse, allPeriodEarnings
                    }
                    this.currentSurplusArr = [
                        { title: '本期收入', num: totalIncome },
                        { title: '伙食费收入', num: foodIncome },
                        { title: '财政补助收入', num: financialSubsidyIncome },
                        { title: '学校补助收入', num: schoolSubsidyIncome },
                        { title: '利息收入', num: interestIncome }, { title: '其他收入', num: otherIncome } ]
                    this.currentExpensesArr = [ { title: '本期费用', num: totalFee },
                    { title: '伙食成本费用', num: foodCostFee },
                    { title: '资产处置费用', num: assetDisposalFee }
                    ]
                }
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getShowDivs();
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        setInterval(() => {
            this.getData()
        }, 360000);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang='scss' scoped>
.page_index {
    height: 100%;
    .body_part {
        width: 100%;
        @include flex(space-around);
        height: vh(976);
        // padding: vh(18) 0 vh(20) 0;
        box-sizing: border-box;
        > div {
            height: 100%;
        }
        .left {
            @include flex(space-between);
            padding-top: vh(6);
        }
    }
    .page_line {
        width: 90%;
        height: vh(1);
        margin: 0 auto;
        background: linear-gradient(
            to right,
            #00048f 0%,
            #00048f 10%,
            #00558b 20%,
            #00558b 30%,
            #00558b 40%,
            #00558b 50%,
            #00558b 60%,
            #00558b 70%,
            #00558b 80%,
            #00048f 90%,
            #00048f 100%
        );
    }
    .page_padding {
        padding-top: vh(90);
    }
    .page_right {
        width: 90%;
        margin: 0 auto;
    }
    .page_article {
        padding-top: vh(35);
    }
    .page_line_right {
        width: 80%;
        height: vh(1);
        margin: vh(10) auto auto;
        background: linear-gradient(
            to right,
            #0030ca 0%,
            #1c52ff 10%,
            #1c52ff 20%,
            #1c52ff 30%,
            #1c52ff 40%,
            #1c52ff 50%,
            #1c52ff 60%,
            #1c52ff 70%,
            #1c52ff 80%,
            #1c52ff 90%,
            #0030ca 100%
        );
    }
    // 2022/12/1  新版收入费用公示
    .revenueExpense {
        padding-top: vh(90);
        display: flex;
        color: #fff;
        font-size: vh(18);
        margin-left: vh(140);
    }
    .currentSurplus,
    .currentSurplusActive,
    .currentExpenses,
    .accumulatedSurplus {
        display: flex;
        justify-content: space-between;
        color: #fff;
        font-size: vh(22);
        padding: vh(40) vh(40) vh(30) vh(40);
    }
    .currentSurplusActive {
        font-size: vh(18);
        padding: 0 vh(40) vh(15) vh(60);
    }
    .currentExpenses {
        padding: vh(70) vh(40) vh(30) vh(40);
    }
    .accumulatedSurplus {
        padding: vh(120) vh(40) vh(30) vh(40);
    }
}
</style>